import { call, put, takeLatest } from '@redux-saga/core/effects';
import Apis from '../../../../api';
import { CommonAction } from '../../../login/redux/types';
import MessageActions from '../../../message/redux/actions';
import ReferralsActions from './actions';
import ReferralsTypes, { ReferralData } from './types';

const fetchReferralDetailReq = function* fetchReferralDetailReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const resData: { data: ReferralData[] } = yield call(Apis.getReferralDetail, investmentUUID);
        yield put(ReferralsActions.setReferralDetail(resData.data || undefined));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(ReferralsActions.setReferralDetail([]));
    }
};


export default function* sagas() {
    yield takeLatest(ReferralsTypes.GET_REFERRALS_REQ, fetchReferralDetailReq);
}
